import { render, staticRenderFns } from "./ProductsDemand.vue?vue&type=template&id=37d7f3a4&scoped=true&"
import script from "./ProductsDemand.vue?vue&type=script&lang=js&"
export * from "./ProductsDemand.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDemand.vue?vue&type=style&index=0&id=37d7f3a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7f3a4",
  null
  
)

export default component.exports